import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  
  window.console.log = () => {};
  window.console.error = () => {};
  window.console.warn = () => {};
}

if (!environment.production) {
  enableProdMode();
  window.console.log = () => {};
  window.console.error = () => {};
  window.console.warn = () => {};
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
